import {SafeUrl} from "@angular/platform-browser";

export class AuthDTO {
    name = '';
    imageToShow!: SafeUrl;
    job = '';
    time = '';
    mail = '';
}